import { Fancybox } from '@fancyapps/ui';

export default defineNuxtPlugin(() => {
  window.Fancybox = Fancybox;
});
